import clsx from 'clsx';
import { style } from './product-card-title.module.css';

interface Props {
  title: string;
  enabledTransition?: boolean;
}

export function ProductCardTitle(props: Props) {

  const { 
    title,
    enabledTransition
  } = props;

  return (
    <div className={style.container}>
      <div className={clsx(style.title, enabledTransition && style.transition)}>{title}</div>
    </div>
  );
}
